import React, { useContext, useEffect, useState } from "react"
import { AppContext } from "../../../context/createContext"
import PreviousRounds from "../../gameBoard/rounds/PreviousRounds"
import WinNotification from "../../gameBoard/winNotification/WinNotification"
import { AdditionalInfoWrapper } from "./ElementsStyles"
import Notification from "../../notification/Notification"

export default function AdditionalInfo({ autoActive, isLoading }: any) {
  const { notification, notificationfadeOut, airdrop } = useContext(AppContext)

  const [showAirdrop, setshowAirdrop] = useState(false)
  const [airdropText, setairdroptext] = useState("")

  useEffect(() => {
    setshowAirdrop(true)
    setTimeout(() => {
      setshowAirdrop(false)
    }, 3000)
    if (airdrop.type === "real_money") {
      setairdroptext(`You got ${airdrop.amount} USD in Airdrop`)
    }
    if (airdrop.type === "freespin") {
      setairdroptext(`You got ${airdrop.amount} FREESPINS in Airdrop`)
    }
  }, [airdrop])

  return (
    <AdditionalInfoWrapper autoActive={autoActive}>
      <WinNotification isLoading={isLoading} />
      <PreviousRounds />
      {notification && (
        <Notification
          text={notification}
          fadeOut={notificationfadeOut}
          isError={false}
        />
      )}
      {showAirdrop && airdropText !== "" && (
        <Notification
          text={airdropText}
          fadeOut={notificationfadeOut}
          isAirdrop
        />
      )}
    </AdditionalInfoWrapper>
  )
}
